export default "__VITE_ASSET__DYhKOoj7__"